import { SvgIcon } from "@mui/material"

import { ReactComponent as Incident } from "./Incident.svg"

export const IncidentIcon = (props) => {
    return (
        <SvgIcon component={Incident} {...props} inheritViewBox />
    )
}